import * as React from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

interface WorkoutListCardProps {
    icon: React.ReactNode;
    title: string;
    subtitle: string;
    onClick: () => void;
    badge?: string;
}

export default function WorkoutListCard({
    icon,
    title,
    subtitle,
    onClick,
    badge,
}: WorkoutListCardProps): React.JSX.Element {
    return (
        <Box
            onClick={onClick}
            sx={{
                backgroundColor: "#243049",
                borderRadius: "12px",
                padding: "10px",
                display: "flex",
                alignItems: "center",
                gap: "15px",
                cursor: "pointer",
                transition: "background 0.2s",
                "&:active": {
                    backgroundColor: "#26334d",
                },
            }}
        >
            <Box
                sx={{
                    width: 30,
                    display: "flex",
                    justifyContent: "center",
                    fontSize: "1.5rem",
                }}
            >
                {icon}
            </Box>
            <Stack spacing={0.25}>
                <Typography
                    variant="body1"
                    sx={{
                        color: "white",
                        fontWeight: 700,
                        fontSize: "1.1rem",
                    }}
                >
                    {title}
                </Typography>
                <Typography
                    variant="body2"
                    sx={{
                        color: "#94a3b8",
                        fontSize: "0.8rem",
                        fontWeight: 400,
                    }}
                >
                    {subtitle}
                </Typography>
            </Stack>
            {badge && (
                <Box
                    component="span"
                    sx={{
                        marginLeft: "auto",
                        flexShrink: 0,
                        backgroundColor: "rgba(60,233,124,0.15)",
                        color: "#3CE97C",
                        fontSize: "0.62rem",
                        fontWeight: 800,
                        letterSpacing: "0.08em",
                        textTransform: "uppercase",
                        padding: "2px 5px",
                        borderRadius: "999px",
                    }}
                >
                    {badge}
                </Box>
            )}
        </Box>
    );
}
